import { render, staticRenderFns } from "./ModuleHome.vue?vue&type=template&id=531d4255&scoped=true&"
import script from "./ModuleHome.vue?vue&type=script&lang=js&"
export * from "./ModuleHome.vue?vue&type=script&lang=js&"
import style0 from "./ModuleHome.vue?vue&type=style&index=0&id=531d4255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d4255",
  null
  
)

export default component.exports